// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.download-advanced-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 20px;
  animation: downloadAdvancedFadeIn 0.2s ease-out;
}

@keyframes downloadAdvancedFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.download-advanced-modal {
  position: relative;
  background: #1a1a1a;
  border: 1px solid #2d2d2d;
  border-radius: 16px;
  width: 100%;
  max-width: 480px;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.6);
  overflow: hidden;
  animation: downloadAdvancedSlide 0.3s ease-out;
}

@keyframes downloadAdvancedSlide {
  from {
    opacity: 0;
    transform: translateY(-12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.download-advanced-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #2d2d2d;
}

.download-advanced-header h2 {
  font-size: 18px;
  font-weight: 600;
  color: #e0e0e0;
  margin: 0;
}

.download-advanced-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
  border-radius: 8px;
  transition: background 0.15s, color 0.15s;
}

.download-advanced-close:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #e0e0e0;
}

.download-advanced-body {
  padding: 20px;
}

.download-advanced-camera {
  font-size: 13px;
  color: #9ca3af;
  margin: 0 0 16px 0;
}

.download-advanced-field {
  margin-bottom: 16px;
}

.download-advanced-field > label {
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: #9ca3af;
  margin-bottom: 6px;
}

.download-advanced-datetime {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.download-advanced-datetime input {
  flex: 1 1;
  min-width: 160px;
  padding: 10px 12px;
  font-size: 14px;
  border: 1px solid #2d2d2d;
  border-radius: 8px;
  background: #252525;
  color: #e0e0e0;
}

.download-advanced-datetime input::-webkit-calendar-picker-indicator {
  filter: invert(1);
  cursor: pointer;
}

.download-advanced-datetime input::-moz-calendar-picker-indicator {
  filter: invert(1);
  cursor: pointer;
}

.download-advanced-datetime input:focus {
  outline: none;
  border-color: #4a9eff;
}

.download-advanced-sep {
  font-size: 13px;
  color: #6b7280;
}

.download-advanced-duration {
  display: flex;
  gap: 8px;
}

.download-advanced-duration-option {
  flex: 1 1;
  padding: 10px 12px;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid #2d2d2d;
  border-radius: 8px;
  background: #252525;
  color: #9ca3af;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s, color 0.15s;
}

.download-advanced-duration-option:hover:not(.is-selected) {
  border-color: #3d3d3d;
  color: #e0e0e0;
}

.download-advanced-duration-option:focus-visible {
  outline: none;
  border-color: #4a9eff;
}

.download-advanced-duration-option.is-selected {
  border-color: #4a9eff;
  background: rgba(74, 158, 255, 0.15);
  color: #e0e0e0;
}

.download-advanced-field select {
  width: 100%;
  padding: 10px 12px;
  font-size: 14px;
  border: 1px solid #2d2d2d;
  border-radius: 8px;
  background: #252525;
  color: #e0e0e0;
  cursor: pointer;
}

.download-advanced-field select:focus {
  outline: none;
  border-color: #4a9eff;
}

.download-advanced-field input[type='text'] {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px;
  font-size: 14px;
  border: 1px solid #2d2d2d;
  border-radius: 8px;
  background: #252525;
  color: #e0e0e0;
}

.download-advanced-field input[type='text']:focus {
  outline: none;
  border-color: #a61b34;
}

.download-advanced-format-note {
  margin: 0 0 12px;
  font-size: 12px;
  line-height: 1.45;
  color: #9ca3af;
}

.download-advanced-error {
  font-size: 12px;
  color: #f87171;
  margin: 6px 0 0 0;
}

.download-advanced-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid #2d2d2d;
}

.download-advanced-btn {
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s, opacity 0.15s;
}

.download-advanced-btn.secondary {
  border: 1px solid #2d2d2d;
  background: transparent;
  color: #e0e0e0;
}

.download-advanced-btn.secondary:hover {
  background: rgba(255, 255, 255, 0.06);
}

.download-advanced-btn.primary {
  border: none;
  background: #4a9eff;
  color: #fff;
}

.download-advanced-btn.primary:hover:not(:disabled) {
  background: #3b8eef;
}

.download-advanced-btn.primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/DownloadAdvancedModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,+CAA+C;AACjD;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".download-advanced-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.85);\n  backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n  padding: 20px;\n  animation: downloadAdvancedFadeIn 0.2s ease-out;\n}\n\n@keyframes downloadAdvancedFadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.download-advanced-modal {\n  position: relative;\n  background: #1a1a1a;\n  border: 1px solid #2d2d2d;\n  border-radius: 16px;\n  width: 100%;\n  max-width: 480px;\n  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.6);\n  overflow: hidden;\n  animation: downloadAdvancedSlide 0.3s ease-out;\n}\n\n@keyframes downloadAdvancedSlide {\n  from {\n    opacity: 0;\n    transform: translateY(-12px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.download-advanced-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid #2d2d2d;\n}\n\n.download-advanced-header h2 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #e0e0e0;\n  margin: 0;\n}\n\n.download-advanced-close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border: none;\n  background: transparent;\n  color: #9ca3af;\n  cursor: pointer;\n  border-radius: 8px;\n  transition: background 0.15s, color 0.15s;\n}\n\n.download-advanced-close:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #e0e0e0;\n}\n\n.download-advanced-body {\n  padding: 20px;\n}\n\n.download-advanced-camera {\n  font-size: 13px;\n  color: #9ca3af;\n  margin: 0 0 16px 0;\n}\n\n.download-advanced-field {\n  margin-bottom: 16px;\n}\n\n.download-advanced-field > label {\n  display: block;\n  font-size: 12px;\n  font-weight: 500;\n  color: #9ca3af;\n  margin-bottom: 6px;\n}\n\n.download-advanced-datetime {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.download-advanced-datetime input {\n  flex: 1;\n  min-width: 160px;\n  padding: 10px 12px;\n  font-size: 14px;\n  border: 1px solid #2d2d2d;\n  border-radius: 8px;\n  background: #252525;\n  color: #e0e0e0;\n}\n\n.download-advanced-datetime input::-webkit-calendar-picker-indicator {\n  filter: invert(1);\n  cursor: pointer;\n}\n\n.download-advanced-datetime input::-moz-calendar-picker-indicator {\n  filter: invert(1);\n  cursor: pointer;\n}\n\n.download-advanced-datetime input:focus {\n  outline: none;\n  border-color: #4a9eff;\n}\n\n.download-advanced-sep {\n  font-size: 13px;\n  color: #6b7280;\n}\n\n.download-advanced-duration {\n  display: flex;\n  gap: 8px;\n}\n\n.download-advanced-duration-option {\n  flex: 1;\n  padding: 10px 12px;\n  font-size: 14px;\n  font-weight: 500;\n  border: 1px solid #2d2d2d;\n  border-radius: 8px;\n  background: #252525;\n  color: #9ca3af;\n  cursor: pointer;\n  transition: border-color 0.15s, background 0.15s, color 0.15s;\n}\n\n.download-advanced-duration-option:hover:not(.is-selected) {\n  border-color: #3d3d3d;\n  color: #e0e0e0;\n}\n\n.download-advanced-duration-option:focus-visible {\n  outline: none;\n  border-color: #4a9eff;\n}\n\n.download-advanced-duration-option.is-selected {\n  border-color: #4a9eff;\n  background: rgba(74, 158, 255, 0.15);\n  color: #e0e0e0;\n}\n\n.download-advanced-field select {\n  width: 100%;\n  padding: 10px 12px;\n  font-size: 14px;\n  border: 1px solid #2d2d2d;\n  border-radius: 8px;\n  background: #252525;\n  color: #e0e0e0;\n  cursor: pointer;\n}\n\n.download-advanced-field select:focus {\n  outline: none;\n  border-color: #4a9eff;\n}\n\n.download-advanced-field input[type='text'] {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 10px 12px;\n  font-size: 14px;\n  border: 1px solid #2d2d2d;\n  border-radius: 8px;\n  background: #252525;\n  color: #e0e0e0;\n}\n\n.download-advanced-field input[type='text']:focus {\n  outline: none;\n  border-color: #a61b34;\n}\n\n.download-advanced-format-note {\n  margin: 0 0 12px;\n  font-size: 12px;\n  line-height: 1.45;\n  color: #9ca3af;\n}\n\n.download-advanced-error {\n  font-size: 12px;\n  color: #f87171;\n  margin: 6px 0 0 0;\n}\n\n.download-advanced-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 20px;\n  border-top: 1px solid #2d2d2d;\n}\n\n.download-advanced-btn {\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 500;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.15s, opacity 0.15s;\n}\n\n.download-advanced-btn.secondary {\n  border: 1px solid #2d2d2d;\n  background: transparent;\n  color: #e0e0e0;\n}\n\n.download-advanced-btn.secondary:hover {\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.download-advanced-btn.primary {\n  border: none;\n  background: #4a9eff;\n  color: #fff;\n}\n\n.download-advanced-btn.primary:hover:not(:disabled) {\n  background: #3b8eef;\n}\n\n.download-advanced-btn.primary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
